/* Instant search for the header search panel (snippets/header-search-panel.liquid): the
   wide-desktop field and, on phones and tablets, the field under the logo. One panel serves
   both; whichever field is in use drives it.
   Values that come from Liquid (routes, the customer, the search just made) are read from
   data attributes on the panel, so this file is the same on every page and stays cached. */
(function () {
  function init() {
    var panel = document.querySelector('[data-header-search-panel]');
    var header = panel && panel.closest('.header');
    var forms = header ? Array.prototype.slice.call(header.querySelectorAll('.header-search-field')) : [];
    if (!panel || !forms.length) return;

    /* The field in use (set as one is focused, typed in or pressed). */
    var form = forms[0];
    var field = form.querySelector('input[type="search"]');
    function use(next) {
      if (next === form) return;
      form = next;
      field = form.querySelector('input[type="search"]');
    }
    function inForms(target) {
      return forms.some(function (element) { return element.contains(target); });
    }
    var quick = panel.querySelector('[data-header-search-quick]');
    var results = panel.querySelector('[data-header-search-results]');
    var history = panel.querySelector('[data-header-search-history]');
    var recentSearches = panel.querySelector('[data-header-search-recent-searches]');
    var recentList = panel.querySelector('[data-header-search-recent-list]');
    var recentProducts = panel.querySelector('[data-header-search-recent-products]');
    var recentGrid = panel.querySelector('[data-header-search-recent-grid]');
    var allTemplate = panel.querySelector('[data-header-search-all]');
    var searchUrl = panel.getAttribute('data-search-url');
    var collectionUrl = panel.getAttribute('data-collection-url');
    var customerKey = panel.getAttribute('data-customer-key');
    var refocusing = false;

    /* The full prompt needs about 250px; a narrower field says less rather than truncate. */
    forms.forEach(function (element) {
      var input = element.querySelector('input[type="search"]');
      var shortText = input.placeholder;
      var longText = input.getAttribute('data-placeholder-long');
      if (window.ResizeObserver && longText) {
        new ResizeObserver(function (entries) {
          input.placeholder = entries[0].contentRect.width >= 250 ? longText : shortText;
        }).observe(input);
      }
    });

    /* History lives in this browser only. Storage can throw (Safari private mode), in
       which case the panel simply has no history and shows the quick links. */
    var SEARCHES_KEY = 'mcs:recent-searches';
    var VIEWED_KEY = 'Concept:recently-viewed'; /* written by snippets/js-variables.liquid */

    function readList(key) {
      try {
        var list = JSON.parse(window.localStorage.getItem(key) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    }

    function rememberSearch(query) {
      query = String(query || '').trim();
      if (!query || /^id:/i.test(query)) return;
      var list = readList(SEARCHES_KEY).filter(function (item) {
        return String(item).toLowerCase() !== query.toLowerCase();
      });
      list.unshift(query);
      try { window.localStorage.setItem(SEARCHES_KEY, JSON.stringify(list.slice(0, 6))); } catch (error) {}
    }

    /* Shopify already HTML-escapes search.terms and the Liquid escapes it again
       for the attribute, so one level of entities survives into the value
       (a search for 5" showed as 5&quot;). Decode that level in an inert
       document; the term is only ever shown via textContent. */
    var decodeEntities = function (value) {
      if (!value || value.indexOf('&') === -1) return value;
      try {
        return new DOMParser().parseFromString(value, 'text/html').documentElement.textContent || value;
      } catch (error) {
        return value;
      }
    };

    /* A search page prerendered on a link press is only remembered once it is shown. */
    var searchedFor = decodeEntities(panel.getAttribute('data-searched-for'));
    if (searchedFor && document.prerendering) {
      document.addEventListener('prerenderingchange', function () { rememberSearch(searchedFor); }, { once: true });
    } else if (searchedFor) {
      rememberSearch(searchedFor);
    }

    /* ---- The catalogue, searched in the browser ------------------------------------
       Every keystroke is answered from a copy of the catalogue held here, so products
       change with each letter. The copy comes from sections/header-search-index.liquid,
       rendered in this customer's session (so its prices are theirs), and is kept for
       the session. Until it arrives, or when it finds nothing (a misspelling, say), the
       products come from Shopify's predictive search as before. */
    /* Bump the version when tile markup changes, so no session keeps the old tiles. */
    var INDEX_KEY = 'mcs:search-index:v6:' + customerKey;
    var INDEX_TTL = 30 * 60 * 1000;
    var catalogue = null;       /* [{ id, title, words, other, available, template }] */
    var tiles = {};             /* id -> tile element, reused so pictures don't reload */
    var loadingCatalogue = false;

    function normalise(text) {
      return String(text || '').toLowerCase().replace(/['\u2019]/g, '').normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function useCatalogue(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var popularNode = doc.getElementById('HeaderSearchPopular');
      try {
        var published = popularNode ? JSON.parse(popularNode.textContent) : null;
        popular = (published && published.terms || []).map(function (item) {
          return normalise(item[0]);
        }).filter(Boolean);
      } catch (error) {
        popular = [];
      }
      catalogue = Array.prototype.map.call(doc.querySelectorAll('template[data-i]'), function (template) {
        var title = normalise(template.getAttribute('data-t'));
        return {
          id: template.getAttribute('data-i'),
          title: title,
          words: title.split(' '),
          /* The title without its bracketed asides (colours, regions), for suggestions. */
          phrase: normalise(template.getAttribute('data-t').replace(/\([^)]*\)/g, ' ')).split(' ').filter(Boolean),
          brand: normalise(template.getAttribute('data-v')),
          type: template.getAttribute('data-y') || '',
          other: normalise(template.getAttribute('data-k')).split(' '),
          available: !template.hasAttribute('data-u'),
          template: template
        };
      });
      buildKeywords();
      if (isOpen()) {
        warmFirstLetters();
        paint();
      }
    }

    function loadCatalogue() {
      if (catalogue || loadingCatalogue) return;
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(INDEX_KEY) || 'null');
        if (saved && Date.now() - saved.at < INDEX_TTL) {
          useCatalogue(saved.html);
          return;
        }
      } catch (error) {}

      loadingCatalogue = true;
      var pages = [];
      var fetchPage = function (page) {
        var url = collectionUrl + '?' + new URLSearchParams({ section_id: 'header-search-index', page: page }).toString();
        return fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var root = new DOMParser().parseFromString(text, 'text/html').getElementById('HeaderSearchIndex');
            if (!root) throw new Error('No search index');
            pages.push(root.innerHTML);
            var total = parseInt(root.getAttribute('data-pages'), 10) || 1;
            if (page < total && page < 8) return fetchPage(page + 1);
          });
      };
      fetchPage(1)
        .then(function () {
          var html = pages.join('');
          try { window.sessionStorage.setItem(INDEX_KEY, JSON.stringify({ at: Date.now(), html: html })); } catch (error) {}
          useCatalogue(html);
        })
        .catch(function () {})
        .then(function () { loadingCatalogue = false; });
    }

    /* True when a and b differ by at most one letter changed, missing or extra. */
    function withinOneEdit(a, b) {
      if (Math.abs(a.length - b.length) > 1) return false;
      var i = 0, j = 0, edits = 0;
      while (i < a.length && j < b.length) {
        if (a[i] === b[j]) { i++; j++; continue; }
        if (++edits > 1) return false;
        if (a.length > b.length) i++;
        else if (a.length < b.length) j++;
        else { i++; j++; }
      }
      return edits + (a.length - i) + (b.length - j) <= 1;
    }

    /* A typed word of four or more letters may be one letter off the start of a title word. */
    function nearlyStarts(word, token) {
      if (token.length < 4) return false;
      for (var length = token.length - 1; length <= token.length + 1; length++) {
        if (withinOneEdit(word.slice(0, length), token)) return true;
      }
      return false;
    }

    /* Every word typed has to start a word of the product: in the title (worth most, more
       the earlier it sits), in its brand, type or SKUs, or failing those, a title word
       it is one letter off (so "bialeti" still finds Bialetti). */
    function rankProducts(query) {
      var tokens = normalise(query).split(' ').filter(Boolean);
      if (!tokens.length) return [];
      var phrase = tokens.join(' ');
      var scored = [];
      for (var i = 0; i < catalogue.length; i++) {
        var entry = catalogue[i];
        var score = 0;
        var matched = true;
        for (var t = 0; t < tokens.length && matched; t++) {
          var token = tokens[t];
          var position = -1;
          for (var w = 0; w < entry.words.length; w++) {
            if (entry.words[w].indexOf(token) === 0) { position = w; break; }
          }
          if (position >= 0) {
            score += 10 - Math.min(position, 6) + (entry.words[position] === token ? 2 : 0);
          } else if (entry.other.some(function (word) { return word.indexOf(token) === 0; })) {
            score += 4;
          } else {
            position = -1;
            for (var n = 0; n < entry.words.length; n++) {
              if (nearlyStarts(entry.words[n], token)) { position = n; break; }
            }
            if (position >= 0) score += 5 - Math.min(position, 4);
            else matched = false;
          }
        }
        if (!matched) continue;
        if (entry.title.indexOf(phrase) === 0) score += 6;
        if (!entry.available) score -= 8;
        score -= entry.words.length * 0.1;
        scored.push({ score: score, entry: entry });
      }
      scored.sort(function (a, b) { return b.score - a.score; });
      return scored.map(function (item) { return item.entry; });
    }

    function findProducts(query, limit) {
      return rankProducts(query).slice(0, limit || 6);
    }

    /* Imported into the page's own document (a plain clone stays inert, like its
       template), so a tile's picture starts downloading the moment the tile is made,
       whether or not it is on screen yet. */
    function tileFor(entry) {
      if (!tiles[entry.id]) {
        tiles[entry.id] = document.importNode(entry.template.content.firstElementChild, true);
      }
      return tiles[entry.id];
    }

    /* Pictures are fetched before they are needed, by making tiles ahead, a few at a time
       while the browser is idle. What is asked for most recently goes first: another
       letter only narrows the matches, so the current query's next best are what it will
       bring up. Those likely soonest are decoded too, so their first frame is not blank. */
    var warmQueue = [];
    var warming = false;

    function warmTiles(entries, decode) {
      var fresh = entries.filter(function (entry) { return !tiles[entry.id]; })
        .map(function (entry) { return { entry: entry, decode: decode }; });
      if (!fresh.length) return;
      var ids = {};
      fresh.forEach(function (item) { ids[item.entry.id] = true; });
      warmQueue = fresh.concat(warmQueue.filter(function (item) { return !ids[item.entry.id]; }));
      if (warming) return;
      warming = true;
      var idle = window.requestIdleCallback || function (callback) { setTimeout(callback, 50); };
      var step = function () {
        warmQueue.splice(0, 8).forEach(function (item) {
          if (tiles[item.entry.id]) return;
          var image = tileFor(item.entry).querySelector('img');
          if (item.decode && image && image.decode) image.decode().catch(function () {});
        });
        if (warmQueue.length) idle(step);
        else warming = false;
      };
      idle(step);
    }

    /* Once the search is in use (pointer on it, or opened): the top six for every first
       letter, which has nothing before it to narrow from, then the rest of the catalogue
       behind them. The browser keeps the pictures, so later pages cost nothing. Once per page. */
    var warmedLetters = false;

    function warmFirstLetters() {
      if (warmedLetters || !catalogue) return;
      warmedLetters = true;
      var entries = [];
      'abcdefghijklmnopqrstuvwxyz0123456789'.split('').forEach(function (letter) {
        entries = entries.concat(findProducts(letter, 6));
      });
      warmTiles(catalogue, false);
      warmTiles(entries, true);
    }

    /* ---- Keyword suggestions, made from the catalogue ------------------------------
       Phrases that start with what is typed, cut from product titles, plus a model or
       brand joined to what the product is ("df54" + Grinders = "df54 grinder"). A phrase
       has to end on something a customer would search for: a product noun (the tail of a
       product type, or a word that ends at least three titles), a model like "e8" or
       "1100s", or a brand. Ranked by how many products each finds, shortest first. */
    var STOP_WORDS = toSet('and with for the of in a an to x by on per or from your our new clearance ex demo second hand inta intd only edition version gen ii iii set pack pk pcs piece pieces litre litres liter gram grams ml kg g l oz single double dose size small large mini maxi line end blend plus pro');
    var COLOURS = toSet('black white silver grey gray red blue green chrome matte brushed gold copper pink orange yellow purple brown cream piano midnight coal emerald floss stainless steel glass clear ivory charcoal graphite platinum bronze teal navy mint sand stone');
    var WEAK_NOUNS = toSet('equipment accessory supply product other misc service item part spare general gift card voucher coffee tea clean connect glas set pack chest');
    var TYPE_ADJECTIVES = toSet('home commercial manual automatic office workplace ground reusable instant disposable fully semi super espresso');
    var MODIFIERS = toSet('coffee milk water tea espresso cleaning descaling'); /* never the last word before a noun */
    var SIZE = /^\d+(\.\d+)?(ml|l|g|gm|gms|gram|grams|kg|mm|cm|oz|pk|pack|cup|cups|x|litre|litres|liter|pcs)?$/;
    var keywords = null;        /* { nouns, brands, brandNames } */
    var vocabulary = null;      /* word -> number of products using it */
    var popular = [];           /* customers' own searches, most searched first */

    function toSet(words) {
      var set = {};
      words.split(' ').forEach(function (word) { set[word] = true; });
      return set;
    }

    function singular(word) {
      if (/(ss|us|is)$/.test(word)) return word;
      return word.replace(/ies$/, 'y').replace(/(ches|shes|xes|sses)$/, function (end) { return end.slice(0, -2); }).replace(/s$/, '');
    }

    function isModel(word) {
      return /[a-z]/.test(word) && /\d/.test(word) && !SIZE.test(word);
    }

    function stems(words) {
      return words.map(function (word) { return singular(word).slice(0, 5); });
    }

    function repeats(words) {
      var seen = {};
      return stems(words).some(function (stem) { if (seen[stem]) return true; seen[stem] = true; return false; });
    }

    /* "Home Manual Coffee Machines" -> "coffee machine"; "Grinders" -> "grinder". */
    function typeNoun(type) {
      var words = normalise(type).split(' ').filter(function (word) { return word && !TYPE_ADJECTIVES[word]; });
      if (!words.length) return '';
      var noun = singular(words[words.length - 1]);
      if (WEAK_NOUNS[noun]) return '';
      var before = words[words.length - 2];
      return before && MODIFIERS[before] && before !== noun ? before + ' ' + noun : noun;
    }

    function buildKeywords() {
      var nouns = {}, brands = {}, brandNames = {}, endings = {};
      catalogue.forEach(function (entry) {
        entry.noun = typeNoun(entry.type);
        if (entry.noun) nouns[entry.noun.split(' ').pop()] = true;
        if (entry.brand) {
          brandNames[entry.brand] = true;
          brands[entry.brand.split(' ')[0]] = true;
        }
        var last = singular(entry.phrase[entry.phrase.length - 1] || '');
        endings[last] = (endings[last] || 0) + 1;
      });
      Object.keys(endings).forEach(function (word) {
        if (endings[word] >= 3 && word.length > 2 && !COLOURS[word] && !STOP_WORDS[word] && !SIZE.test(word)
          && !isModel(word) && !WEAK_NOUNS[word] && !MODIFIERS[word]) nouns[word] = true;
      });
      keywords = { nouns: nouns, brands: brands, brandNames: brandNames };

      /* Every word a product is known by, and how many products use it, for completing
         typed words in the search page query. */
      vocabulary = {};
      catalogue.forEach(function (entry) {
        var seen = {};
        entry.words.concat(entry.other).forEach(function (word) {
          if (!word || seen[word]) return;
          seen[word] = true;
          vocabulary[word] = (vocabulary[word] || 0) + 1;
        });
      });
    }

    function endsWell(words, next, typed) {
      var word = words[words.length - 1];
      if (word.length < 2 || STOP_WORDS[word] || SIZE.test(word) || repeats(words)) return false;
      if (typed) return !COLOURS[word] || words.length === 1;   /* the word being typed, finished */
      if (COLOURS[word]) return false;
      if (next && MODIFIERS[word]) return false;                 /* not "df54 coffee" of "df54 coffee grinder" */
      if (next && keywords.nouns[singular(next)] && !isModel(word)) return false;
      return !!(keywords.nouns[singular(word)] || isModel(word) || keywords.brandNames[words.join(' ')]
        || (words.length === 1 && keywords.brands[word]));
    }

    function suggestKeywords(query, limit) {
      var typed = normalise(query).split(' ').filter(Boolean);
      if (!typed.length || !keywords) return [];
      var last = typed[typed.length - 1];
      var before = typed.slice(0, -1);
      var found = {};
      var add = function (phrase, id) {
        (found[phrase] = found[phrase] || {})[id] = true;
      };
      catalogue.forEach(function (entry) {
        var words = entry.phrase;
        for (var i = 0; i < words.length; i++) {
          if (words[i].indexOf(last) !== 0) continue;
          var start = i - before.length;
          if (start < 0) continue;
          var fits = true;
          for (var b = 0; b < before.length && fits; b++) fits = words[start + b] === before[b];
          if (!fits) continue;
          for (var end = i; end < Math.min(words.length, i + 4); end++) {
            var slice = words.slice(start, end + 1);
            if (endsWell(slice, words[end + 1], end === i)) add(slice.join(' '), entry.id);
          }
          if (entry.noun && (isModel(words[i]) || keywords.brands[words[i]])) {
            var joined = words.slice(start, i + 1).concat(entry.noun.split(' '));
            if (!repeats(joined)) add(joined.join(' '), entry.id);
          }
        }
      });
      var ranked = Object.keys(found).map(function (phrase) {
        return { phrase: phrase, count: Object.keys(found[phrase]).length, length: phrase.split(' ').length };
      }).sort(function (a, b) {
        return b.count - a.count || a.length - b.length || (a.phrase < b.phrase ? -1 : 1);
      });
      var seen = {};
      var picked = [];
      for (var r = 0; r < ranked.length && picked.length < limit; r++) {
        var key = stems(ranked[r].phrase.split(' ')).join(' ');
        if (seen[key]) continue;
        seen[key] = true;
        picked.push(ranked[r].phrase);
      }
      return picked;
    }

    /* What customers actually search for, when it fits what is typed: first the searches
       that start with it, then those containing every typed word. */
    function popularFor(query, limit) {
      var typed = normalise(query);
      var tokens = typed.split(' ').filter(Boolean);
      if (!tokens.length) return [];
      var starting = [], containing = [];
      popular.forEach(function (term) {
        if (term.indexOf(typed) === 0) {
          starting.push(term);
          return;
        }
        var words = term.split(' ');
        var fits = tokens.every(function (token) {
          return words.some(function (word) { return word.indexOf(token) === 0; });
        });
        if (fits) containing.push(term);
      });
      return starting.concat(containing).slice(0, limit);
    }

    /* Popular searches first (up to five), then generated phrases, then Shopify's own
       suggestions that still fit what is typed, without repeats: eight at most. */
    function suggestionsFor(query, fromShopify) {
      var typed = normalise(query).split(' ').filter(Boolean);
      var list = [];
      var seen = {};
      var take = function (phrase, cap) {
        var key = stems(phrase.split(' ')).join(' ');
        if (list.length >= cap || seen[key]) return;
        seen[key] = true;
        list.push(phrase);
      };
      popularFor(query, 5).forEach(function (phrase) { take(phrase, 5); });
      if (catalogue) suggestKeywords(query, 8).forEach(function (phrase) { take(phrase, 7); });
      (fromShopify || []).forEach(function (text) {
        var phrase = normalise(text);
        var words = phrase.split(' ');
        var fits = typed.every(function (token) {
          return words.some(function (word) { return word.indexOf(token) === 0; });
        });
        if (phrase && fits) take(phrase, 8);
      });
      return list;
    }

    function suggestionsBlock(query, phrases) {
      var typed = normalise(query);
      var block = document.createElement('div');
      block.className = 'header-search-results__block';
      block.setAttribute('data-block', 'suggestions');
      block.innerHTML = '<p class="header-search-panel__heading">Suggestions</p><ul class="header-search-results__links" role="list"></ul>';
      var list = block.querySelector('ul');
      phrases.forEach(function (phrase) {
        var link = document.createElement('a');
        link.className = 'mega-menu__group-tab header-search-results__query';
        link.href = searchUrl + '?' + searchParams(phrase).toString();
        link.setAttribute('data-query', phrase);
        if (typed && phrase.indexOf(typed) === 0) {
          var mark = document.createElement('mark');
          mark.textContent = phrase.slice(0, typed.length);
          link.append(mark, phrase.slice(typed.length));
        } else {
          link.textContent = phrase;
        }
        var item = document.createElement('li');
        item.appendChild(link);
        list.appendChild(item);
      });
      return block;
    }

    /* ---- Suggestions and fallback products, from Shopify ------------------------------
       Asked on every keystroke and never cancelled. Answers can land out of order; each is
       numbered and an older one never replaces a newer one. Answers are cached, so
       deleting back to an earlier query is instant. */
    var answers = {};           /* query -> { aside, products, empty } */
    var latest = null;          /* the newest answer to arrive, for whatever query */
    var issued = 0;
    var shownRequest = 0;

    function ask(query) {
      if (answers[query]) {
        latest = answers[query];
        return;
      }
      var request = ++issued;
      var params = new URLSearchParams({
        q: query,
        'resources[type]': 'query,product',
        /* Same fields as everywhere else: never tags or descriptions. */
        'resources[options][fields]': 'title,vendor,product_type,variants.sku',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        section_id: 'header-search-results'
      });
      var base = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest';
      panel.setAttribute('data-loading', '');
      fetch(base + '?' + params.toString())
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var node = new DOMParser().parseFromString(text, 'text/html').getElementById('HeaderSearchResults');
          var products = node && node.querySelector('.header-search-results__products');
          var answer = {
            query: query,
            queries: node ? Array.prototype.map.call(node.querySelectorAll('[data-block="suggestions"] a'), function (link) {
              return link.textContent.trim();
            }) : [],
            products: products ? products.innerHTML : '',
            empty: !node || !!node.querySelector('.header-search-results__empty')
          };
          answers[query] = answer;
          if (request === issued) panel.removeAttribute('data-loading');
          if (request < shownRequest) return;
          shownRequest = request;
          latest = answer;
          if (isOpen()) paint();
        })
        .catch(function () {
          if (request === issued) panel.removeAttribute('data-loading');
        });
    }

    /* ---- How many products the search page will list ------------------------------
       Asked of Shopify alongside the suggestions, with the same search the See all link
       opens, so the number matches the page. Newest answer wins, as above. */
    var counts = {};            /* query -> number */
    var latestCount = null;     /* the newest count to arrive, for whatever query */
    var countsIssued = 0;
    var countShown = 0;

    /* ---- The search page query -------------------------------------------------------
       Shopify's search also matches descriptions, so "lelit mara" would list every Lelit
       whose description mentions the Mara. The search page is sent a field-scoped query
       instead: each typed word must be in a product's name, brand, type or SKU — not its
       tags, which describe what it suits and pull in other products. Field queries only match whole words, so a typed word is completed from the
       catalogue ("mar" -> mara), and a one-letter slip is corrected the same way
       ("bialeti" -> bialetti). Each group starts with the word as typed, which is how
       snippets/search-terms-display reads the customer's search back for the page. With
       no catalogue in yet the typed words are used as they are; a scoped search that
       finds nothing falls back to Shopify's own search (main-search does the same). */
    /* Whole words a typed word could mean. They come from the products the rest of the
       search already matches here, so "morning d" completes "d" to dream (the Morning
       Dream) rather than to the catalogue's most common d-words, which would find nothing
       and drop the page back to Shopify's description-wide search. With no local match
       (or no catalogue yet) the whole vocabulary is used. */
    function completions(token, matched) {
      if (!vocabulary) return [token];
      var pool = vocabulary;
      if (matched && matched.length) {
        pool = {};
        matched.forEach(function (entry) {
          var seen = {};
          entry.words.concat(entry.other).forEach(function (word) {
            if (!word || seen[word]) return;
            seen[word] = true;
            pool[word] = (pool[word] || 0) + 1;
          });
        });
      }
      var words = Object.keys(pool);
      var found = words.filter(function (word) { return word.indexOf(token) === 0; });
      if (!found.length && !/\d/.test(token)) {
        found = words.filter(function (word) { return nearlyStarts(word, token); });
      }
      found.sort(function (a, b) {
        return (a === token ? -1 : b === token ? 1 : 0) || pool[b] - pool[a] || a.length - b.length;
      });
      var limit = pool === vocabulary ? 6 : 12;
      return [token].concat(found.filter(function (word) { return word !== token; }).slice(0, limit));
    }

    function scopedQuery(query) {
      var tokens = normalise(query).split(' ').filter(Boolean).slice(0, 6);
      if (!tokens.length) return '';
      var matched = catalogue ? rankProducts(query) : null;
      return tokens.map(function (token) {
        var parts = [];
        completions(token, matched).forEach(function (word, index) {
          parts.push('title:' + word);
          if (index === 0 && vocabulary && !vocabulary[word]) return; /* a partial word: just the anchor */
          if (/\d/.test(word)) parts.push('variants.sku:' + word);
          else parts.push('vendor:' + word, 'product_type:' + word);
        });
        return '(' + parts.join(' OR ') + ')';
      }).join(' AND ');
    }

    function broadParams(query) {
      return new URLSearchParams({ q: query, type: 'product', 'options[prefix]': 'last' });
    }

    function searchParams(query) {
      var scoped = scopedQuery(query);
      return scoped ? new URLSearchParams({ q: scoped, type: 'product' }) : broadParams(query);
    }

    function searchHref(query, broad) {
      return searchUrl + '?' + (broad ? broadParams(query) : searchParams(query)).toString();
    }

    function fetchCount(params) {
      params.set('section_id', 'header-search-count');
      return fetch(searchUrl + '?' + params.toString())
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var node = new DOMParser().parseFromString(text, 'text/html').getElementById('HeaderSearchCount');
          if (!node) throw new Error('No count');
          return parseInt(node.getAttribute('data-count'), 10) || 0;
        });
    }

    /* The count is for the same scoped search the link opens; when that finds nothing,
       the link and count fall back to Shopify's own search. */
    function askCount(query) {
      if (counts[query] !== undefined) {
        latestCount = counts[query];
        return;
      }
      var request = ++countsIssued;
      fetchCount(searchParams(query))
        .then(function (count) {
          if (count > 0) return { count: count, broad: false };
          return fetchCount(broadParams(query)).then(function (broadCount) {
            return { count: broadCount, broad: true };
          });
        })
        .then(function (result) {
          counts[query] = result;
          if (request < countShown) return;
          countShown = request;
          latestCount = result;
          if (isOpen()) paint();
        })
        .catch(function () {});
    }

    /* ---- Drawing the panel -------------------------------------------------------- */
    function paint() {
      var query = field.value.trim();
      if (!query) {
        /* A fresh search starts clean: nothing carried over from the one before. */
        latest = null;
        latestCount = null;
        shownRequest = issued;
        countShown = countsIssued;
        results.hidden = true;
        results.textContent = '';
        renderHistory();
        return;
      }

      var answer = answers[query] || null;
      var ranked = catalogue ? rankProducts(query) : null;
      var found = ranked && ranked.slice(0, 6);
      if (ranked) warmTiles(ranked.slice(6, 48), true);
      var shopify = answer || latest || {};
      var phrases = suggestionsFor(query, shopify.queries);
      var products = null;
      if (found && found.length) {
        products = found.map(tileFor);
      } else if (answer || (!catalogue && latest)) {
        products = (answer || latest).products;
      }

      if (!products || !products.length) {
        /* Shopify has answered with nothing at all: say so. */
        if (answer && !phrases.length) {
          results.innerHTML = '<div class="header-search-results__empty"></div>';
          var empty = results.firstChild;
          var title = document.createElement('p');
          title.className = 'header-search-results__empty-title';
          title.textContent = 'No results for “' + query + '”';
          var hint = document.createElement('p');
          hint.className = 'header-search-results__empty-hint';
          hint.textContent = 'Try a product name, a brand or a part number.';
          empty.append(title, hint);
          reveal();
          return;
        }
        /* Shopify has not answered yet: leave any results on screen, but never the history
           or quick links once something is typed. */
        if (!answer) {
          if (results.hidden || !results.firstChild) {
            results.innerHTML = '<p class="header-search-results__searching">Searching…</p>';
            reveal();
          }
          return;
        }
        /* Answered with suggestions but no products: show the suggestions on their own. */
        products = [];
      }

      var groups = document.createElement('div');
      var hasAside = phrases.length > 0;
      groups.className = 'mega-menu__groups header-search-results__groups' + (hasAside ? '' : ' header-search-results__groups--products');
      if (hasAside) {
        var aside = document.createElement('div');
        aside.className = 'mega-menu__group-tabs header-search-results__aside';
        aside.appendChild(suggestionsBlock(query, phrases));
        groups.appendChild(aside);
      }
      var list = document.createElement('ul');
      list.className = 'mega-menu__grid header-search-results__products';
      list.setAttribute('role', 'list');
      if (typeof products === 'string') list.innerHTML = products;
      else products.forEach(function (tile) { list.appendChild(tile); });
      if (list.children.length) groups.appendChild(list);

      results.textContent = '';
      results.append(groups);

      /* See all only when the search page lists more than the panel shows. Until this
         query's count is in, the last one to arrive stands, like the suggestions. */
      var total = counts[query] !== undefined ? counts[query] : latestCount;
      if (total && total.count > list.children.length) {
        var all = allTemplate.content.firstElementChild.cloneNode(true);
        all.href = searchHref(query, total.broad);
        all.querySelector('[data-text]').textContent = 'See all results (' + total.count + ')';
        results.append(all);
      }
      reveal();
    }

    function reveal() {
      results.hidden = false;
      history.hidden = true;
      quick.hidden = true;
    }

    function isOpen() {
      return panel.hasAttribute('open');
    }

    /* Recent searches or recently viewed products to show before typing. */
    function hasHistory() {
      return readList(SEARCHES_KEY).length > 0 || readList(VIEWED_KEY).length > 0;
    }

    /* Phones and tablets, where the field sits on its own row under the logo. */
    var compact = window.matchMedia('(max-width: 1023px)');

    /* Where the panel starts on screen, so on phones its white runs from under the header to
       the bottom of the screen (snippets/header-search-panel.liquid). Kept up to date while
       open, as the page can move under the sticky header (the iOS keyboard scrolls it). */
    function measureTop() {
      panel.style.setProperty('--mcs-search-panel-top', Math.max(0, panel.getBoundingClientRect().top).toFixed(1) + 'px');
    }
    ['scroll', 'resize'].forEach(function (type) {
      window.addEventListener(type, function () {
        if (isOpen()) measureTop();
      }, { passive: true });
    });

    function open() {
      if (isOpen()) return;
      /* On desktop, with nothing typed and no history, focusing only highlights the field
         (CSS :focus-within); the panel opens with the first keystroke. Phones open it at
         once, on the quick links when there is no history. */
      if (!field.value.trim() && !hasHistory() && !compact.matches) return;
      /* One panel at a time: close any menu that is open. */
      header.querySelectorAll('details[open]').forEach(function (details) {
        if ('open' in details) details.open = false;
      });
      loadCatalogue();
      warmFirstLetters();
      /* Nothing typed: start from the history, with no results left from an earlier search. */
      if (!field.value.trim()) paint();
      measureTop();
      panel.setAttribute('open', '');
      document.body.classList.add('header-search-open');
      field.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (!isOpen()) return;
      panel.removeAttribute('open');
      document.body.classList.remove('header-search-open');
      field.setAttribute('aria-expanded', 'false');
    }

    /* Before typing: recent searches and recently viewed. With neither, the panel stays
       closed until the first keystroke (open()); the quick links are only a fallback for
       saved history that can't be shown. The saved ids decide the layout straight away: recently viewed comes
       from the catalogue when it is in, and otherwise loads behind a placeholder per
       product, so the quick links never flash up first. */
    var viewedKey = null;

    function settleHistory() {
      /* Recently viewed can finish loading after typing has started: the history stays away. */
      if (field.value.trim()) {
        history.hidden = true;
        quick.hidden = true;
        return;
      }
      var hasSearches = !recentSearches.hidden;
      var hasProducts = !recentProducts.hidden;
      history.hidden = !(hasSearches || hasProducts);
      history.classList.toggle('header-search-results__groups--products', !(hasSearches && hasProducts));
      quick.hidden = !history.hidden;
    }

    function renderHistory() {
      var searches = readList(SEARCHES_KEY);
      recentList.textContent = '';
      searches.forEach(function (query) {
        var link = document.createElement('a');
        link.className = 'mega-menu__group-tab';
        link.href = searchUrl + '?' + searchParams(query).toString();
        link.textContent = query;
        var item = document.createElement('li');
        item.appendChild(link);
        recentList.appendChild(item);
      });
      recentSearches.hidden = !searches.length;

      var ids = readList(VIEWED_KEY).slice(0, 6).map(String);
      var key = ids.join(',') + (catalogue ? ':catalogue' : '');
      if (!ids.length) {
        viewedKey = null;
        recentProducts.hidden = true;
      } else if (key !== viewedKey) {
        viewedKey = key;
        if (catalogue) {
          var byId = {};
          catalogue.forEach(function (entry) { byId[entry.id] = entry; });
          var list = document.createElement('ul');
          list.className = 'mega-menu__grid header-search-results__products';
          list.setAttribute('role', 'list');
          ids.forEach(function (id) {
            if (byId[id]) list.appendChild(document.importNode(byId[id].template.content.firstElementChild, true));
          });
          recentGrid.textContent = '';
          if (list.children.length) recentGrid.appendChild(list);
          recentProducts.hidden = !list.children.length;
        } else {
          recentGrid.innerHTML = placeholders(ids.length);
          recentProducts.hidden = false;
          var url = searchUrl + '?' + new URLSearchParams({
            type: 'product',
            q: ids.map(function (id) { return 'id:' + id; }).join(' OR '),
            section_id: 'header-search-results'
          }).toString();
          fetch(url)
            .then(function (response) { return response.text(); })
            .then(function (text) {
              if (key !== viewedKey) return;
              var node = new DOMParser().parseFromString(text, 'text/html').getElementById('HeaderSearchResults');
              var grid = node && node.querySelector('li') ? node.innerHTML.trim() : '';
              recentGrid.innerHTML = grid;
              recentProducts.hidden = !grid;
              settleHistory();
            })
            .catch(function () {
              if (key !== viewedKey) return;
              viewedKey = null; /* try again next time the panel opens */
              recentProducts.hidden = true;
              settleHistory();
            });
        }
      }
      settleHistory();
    }

    function placeholders(count) {
      var tile = '<li class="header-search-placeholder" aria-hidden="true">'
        + '<span class="mega-menu__grid-media header-search-placeholder__media"></span>'
        + '<span class="header-search-placeholder__line"></span>'
        + '<span class="header-search-placeholder__line header-search-placeholder__line--short"></span>'
        + '</li>';
      return '<ul class="mega-menu__grid header-search-results__products" role="list">' + new Array(count + 1).join(tile) + '</ul>';
    }

    function firstLink() {
      var visible = [results, history, quick].filter(function (element) { return !element.hidden; })[0];
      return visible && visible.querySelector('a[href]');
    }

    /* Warm up while the page is idle, so the first keystroke already has the catalogue.
       Only where the field shows; a session that has it already reads it from storage. */
    if (window.matchMedia('(min-width: 1440px)').matches) {
      var warm = function () {
        (window.requestIdleCallback || function (callback) { setTimeout(callback, 1500); })(loadCatalogue);
      };
      if (document.readyState === 'complete') warm();
      else window.addEventListener('load', warm, { once: true });
    }

    forms.forEach(function (element) {
      var input = element.querySelector('input[type="search"]');
      input.addEventListener('focus', function () {
        /* With the menu drawer open, the panel opens over it (the header is lifted above the
           drawer while searching) and the menu is still there when the search closes. */
        if (form !== element && isOpen()) close();
        use(element);
        if (!refocusing) open();
      });
      /* Start on the history as the pointer arrives, so it is usually in before the click. */
      element.addEventListener('pointerenter', function () {
        loadCatalogue();
        warmFirstLetters();
        if (!isOpen() && !input.value.trim()) renderHistory();
      });
      input.addEventListener('click', function () {
        use(element);
        open();
      });
      input.addEventListener('input', function () {
        use(element);
        var query = field.value.trim();
        /* Cleared with no history to fall back on: back to just the highlighted field
           (desktop; phones keep the panel, on the quick links). */
        if (!query && !hasHistory() && !compact.matches) {
          paint();
          close();
          return;
        }
        open();
        if (query) {
          ask(query);
          askCount(query);
        }
        paint();
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' && isOpen() && firstLink()) {
          event.preventDefault();
          firstLink().focus();
        }
      });
      element.addEventListener('click', function (event) {
        if (event.target !== input) input.focus();
      });
    });
    /* Phones: the X top right (shown while the panel is open) clears the field and closes the
       panel; an open menu drawer underneath is left as it was. */
    var cancelButton = header.querySelector('[data-header-search-cancel]');
    if (cancelButton) {
      /* Pressing it mustn't take focus from the field: that would close the panel (focusout),
         hide the X and let the tap land on the cart now showing under it. */
      ['pointerdown', 'mousedown'].forEach(function (type) {
        cancelButton.addEventListener(type, function (event) { event.preventDefault(); });
      });
      cancelButton.addEventListener('click', function () {
        field.value = '';
        close();
        field.blur();
      });
    }

    /* Any storefront search form (this field, the drawer, the search page's own box)
       opens the scoped search, so every way in lands on the same results. */
    document.addEventListener('submit', function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('form[action$="/search"]')) return;
      var input = target.querySelector('input[name="q"]');
      var query = input && input.value.trim();
      if (!query) return;
      event.preventDefault();
      rememberSearch(query);
      var known = counts[query];
      window.location.href = searchHref(query, known && known.broad);
    });

    /* Picking a result counts as a search: for the suggestion picked, or what was typed. */
    results.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link) rememberSearch(link.getAttribute('data-query') || field.value);
    });

    panel.querySelector('[data-header-search-clear]').addEventListener('click', function () {
      try { window.localStorage.removeItem(SEARCHES_KEY); } catch (error) {}
      /* Nothing left to show before typing: back to just the highlighted field. */
      if (!hasHistory()) close();
      else renderHistory();
      field.focus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isOpen()) return;
      var fromPanel = panel.contains(document.activeElement);
      close();
      if (fromPanel) {
        refocusing = true;
        field.focus();
        refocusing = false;
      }
    });

    /* Clicks outside close it, including on the dimmed page. Not the click that ends a press
       begun in the field: on phones, focusing the field opens the panel and closes up the
       header, so the finger lifts somewhere else and the click goes to the header around
       both, which would shut the panel as soon as it opened. */
    var pressedInForms = false;
    document.addEventListener('pointerdown', function (event) {
      pressedInForms = inForms(event.target);
    }, true);
    document.addEventListener('click', function (event) {
      var fromField = pressedInForms;
      pressedInForms = false;
      if (fromField) return;
      if (isOpen() && !inForms(event.target) && !panel.contains(event.target)) close();
    });

    /* Phones: scrolling the results from a product closes the keyboard, so the products can
       be seen. Taking focus off the field leaves the panel open (focusout without a related
       target, as below); a tap on a product doesn't move far enough to count. */
    var productTouch = null;
    panel.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      productTouch = compact.matches && event.touches.length === 1 && event.target.closest('.mega-menu__grid-link')
        ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });
    panel.addEventListener('touchmove', function (event) {
      if (!productTouch || document.activeElement !== field) return;
      var touch = event.touches[0];
      if (Math.abs(touch.clientY - productTouch.y) > 8 || Math.abs(touch.clientX - productTouch.x) > 8) {
        productTouch = null;
        field.blur();
      }
    }, { passive: true });

    /* Tabbing away closes it. A click on the panel's blank space has no related target
       and leaves it open. */
    forms.concat(panel).forEach(function (element) {
      element.addEventListener('focusout', function (event) {
        var next = event.relatedTarget;
        if (next && !inForms(next) && !panel.contains(next)) close();
      });
    });

    /* While the panel is open, the header's hover menus open on a click instead of on
       hover, so moving the pointer across the nav on the way to a result doesn't swap
       the search for a mega menu. The theme opens them on mouseenter and, for hover
       menus, makes a click on the heading follow its link; both are caught here first
       (capture phase on the header). Pressing on a heading moves focus out of the field,
       which closes the panel before the click arrives, so whether it was open is taken
       at the press. Once a menu opens the panel closes (below), and hovering works as
       usual again. */
    var hoverMenu = function (target) {
      var details = target && target.closest && target.closest("details[trigger='hover']");
      return details && header.contains(details) ? details : null;
    };
    var pressedWhileOpen = null;
    header.addEventListener('mouseenter', function (event) {
      if (isOpen() && event.target === hoverMenu(event.target)) event.stopImmediatePropagation();
    }, true);
    header.addEventListener('pointerdown', function (event) {
      pressedWhileOpen = isOpen() && event.target.closest('summary') ? hoverMenu(event.target) : null;
    }, true);
    header.addEventListener('click', function (event) {
      var details = pressedWhileOpen;
      pressedWhileOpen = null;
      if (!details || hoverMenu(event.target) !== details || !event.target.closest('summary')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
      details.open = true;
    }, true);

    /* A mega menu opening takes over: the theme marks its summary [open]. */
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].target.hasAttribute('open')) {
          close();
          return;
        }
      }
    });
    header.querySelectorAll('details > summary').forEach(function (summary) {
      observer.observe(summary, { attributes: true, attributeFilter: ['open'] });
    });
  }

  init();

  /* The theme editor re-renders the header without running its scripts again. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-header-search-panel]')) init();
  });
})();
